import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-minority-cell-committee',
  templateUrl: './minority-cell-committee.component.html',
  styleUrls: ['./minority-cell-committee.component.scss']
})
export class MinorityCellCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
